export default {
  header:
    "Le Forum a évolué et s'est développé au fil du temps pour réunir plus de 23 000 participants et 560 conférenciers dans le cadre de cinq conférences annuelles : la Conférence de Montréal, le Toronto Global Forum, le World Strategic Forum, la Conférence de Paris et l’IEFA LatAm Forum, organisés en association avec Integra Capital, et le Phoenix Global Forum, organisé en association avec Phoenix Sister Cities.",
  home: {
    toronto: {
      title: 'Fostering economic resilience',
      date: '11 au 13 octobre 2023',
      content: `<p>Le Toronto Global Forum (TGF) est organisé par le Forum économique international des Amériques (FEIA). La conférence accueille chaque année plus de 170 conférenciers et plusieurs milliers de participants du monde entier.</p>
        <p>Créé en 2006, le TGF rassemble des décideurs de toutes les sphères de la société pour encourager le dialogue et trouver des solutions aux questions nationales et mondiales. En moins de dix ans, le Toronto Global Forum s'est imposé comme l'une des principales plateformes d'Amérique du Nord pour les chefs d'État, les gouverneurs de banques centrales, les ministres, les entrepreneurs et les décideurs économiques mondiaux.</p>
        <p>La 17e édition du Toronto Global Forum se tiendra à l'hôtel Fairmont Royal York du 11 au 13 octobre 2023.</p>`,
      links: {
        learnMore: 'page:toronto',
        tickets: 'https://www.torontoglobalforum.com/#/tickets?affl=MAINWEBSITETGF2023BUYTICKET'
      }
    },
    miami: {
      title: 'Mastering the new economy',
      date: '6 et 7 novembre 2023',
      content: `<p>Le World Strategic Forum (WSF) est une conférence mondiale organisée par le Forum économique international des Amériques (FEIA). Depuis sa création en 2011, le WSF accueille chaque année plus de 100 conférenciers et plus de 3 000 participants du monde entier.</p>
        <p>Les thèmes principaux du World Strategic Forum portent sur l'économie mondiale, la finance, le commerce,l'énergie et l’infrastructure, avec comme mission de relever les défis et les opportunités auxquels sont confrontées les Amériques sur le marché économique mondial.</p>
        <p>La 12e édition du World Strategic Forum aura lieu au Miami Biltmore Hotel, les 6 et 7 novembre 2023.</p>`,
      links: {
        learnMore: 'page:miami',
        tickets:
          'https://www.worldstrategicforum.com/WORLDSTRATEGICFORUM2023-MIAMI-MASTERINGDISRUPTION#/tickets?lang=en'
      }
    },
    paris: {
      title: 'La Conférence de Paris',
      date: '28 et 29 novembre 2023',
      content: `<p>La Conférence de Paris (CDP) est une conférence mondiale organisée par le Forum économique international des Amériques (FEIA). Cet événement annuel sert de plateforme pour rassembler des acteurs majeurs du monde entier afin de discuter du rôle de l'Europe dans l'économie mondiale, dans le but de créer une société plus inclusive, plus équilibrée et plus responsable.</p>
        <p>La 7e édition de la Conférence de Paris se tiendra à Paris, à l'OCDE, les 28 et 29 novembre 2023.</p>`,
      links: {
        learnMore: 'page:paris'
      }
    },
    buenosAires: {
      title: 'IEFA LatAm Forum',
      date: '26 et 27 mars 2024',
      content: `<p>Le IEFA LatAm Forum est une conférence mondiale annuelle organisée par le Forum économique international des Amériques (IEFA) en collaboration avec Integra Capital.</p>
        <p>L’IEFA LatAm Forum a été créé en 2022, avec un intérêt particulier pour le rôle toujours plus important que joue l'Amérique latine dans l'économie mondiale d'aujourd'hui, alors que le monde est à la recherche d'un avenir plus durable et plus résilient.</p>
        <p>La 2e edition de l’IEFA LatAm Forum se tiendra à Buenos Aires, à l’hôtel Four Seasons, les 26 et 27 mars 2024.</p>`,
      links: {
        learnMore: 'page:buenos-aires'
      }
    },
    phoenix: {
      title: 'Forging the Future',
      date: '2 mai 2024',
      content: `<p>Le Phoenix Global Forum est organisé par le FEIA et Phoenix Sister Cities, et sera lancé au printemps 2024. En tant que ville à la croissance la plus rapide des États-Unis depuis cinq ans, la région émerge rapidement comme une plaque tournante pour les organisations dans les secteurs des biosciences, de la technologie, de la durabilité et de la défense. Par conséquent, les investissements extérieurs dirigés vers Phoenix contribuent à créer un écosystème florissant de chefs d'entreprise, d'entrepreneurs, d'investisseurs et d'universitaires.</p>
        <p>Le Phoenix Global Forum servira de plateforme où les décideurs, les leaders d'opinion et les experts dans leurs domaines respectifs se réuniront pour discuter de l'évolution des besoins de la société dans le contexte des défis mondiaux actuels. La conférence mettra en lumière les solutions en cours de développement, tant à Phoenix que dans le monde entier, tout en encourageant l'innovation future par le biais de la connexion et de la collaboration.</p>`,
      links: {
        learnMore: 'page:phoenix'
      }
    },
    montreal: {
      title: 'Conférence de Montréal',
      date: '10 au 12 juin 2024',
      content: `<p>La Conférence de Montréal (CDM) est une conférence international organisée par le Forum économique international des Amériques (FEIA). Elle réunit des centaines de conférenciers et des milliers de participants de partout à travers le monde.</p>
        <p>Lancée en 1994, la Conférence de Montréal (CDM) réunit des décideurs de toutes les sphères de la société pour aborder les plus gros enjeux actuels. Au fil des années, la Conférence de Montréal est devenue un événement international de plusieurs jours, auquel participent des dirigeants mondiaux et des décideurs du monde gouvernemental, des affaires et du milieu universitaire, qui se réunissent pour discuter de sujets allant de l’économie au leadership mondial en passant par le développement durable, l’énergie et l’innovation. La situation géographique de l’événement, au cœur du Canada francophone, offre au public un rare aperçu sociopolitique et économique qui couvre à la fois une perspective nord-américaine et européenne.</p>
        <p>La 30e édition de la Conférence de Montréal aura lieu à Montréal, Québec, du 10 au 12 juin 2024.</p>`,
      links: {
        learnMore: 'page:montreal'
      }
    }
  },
  nextEvents: {
    index: [
      {
        title: 'Fostering economic resilience [EN]',
        conference: 'Toronto Global Forum',
        date: '11 au 13 octobre 2023',
        link: 'https://events.forum-americas.org/TORONTOGLOBALFORUM2023-FOSTERINGECONOMICRESILIENCE',
        image: '/images/events/toronto/toronto-17th-en.png'
      },
      {
        title: 'Mastering the new economy [EN]',
        conference: 'World strategic forum | Miami',
        date: '6 et 7 novembre 2023',
        link: 'https://events.forum-americas.org/WORLDSTRATEGICFORUM2023-MIAMI-MASTERINGDISRUPTION',
        image: '/images/events/miami/miami-12th-en.png'
      },
      {
        title: 'Bridging the divide',
        conference: 'La Conférence de Paris',
        date: '28 et 29 novembre 2023',
        link: 'https://events.forum-americas.org/LACONFERENCEDEPARIS2023#/?lang=fr',
        image: '/images/events/paris/paris-13th-en.png'
      },
      {
        title: '2ème édition',
        conference: 'IEFA LatAm Forum | Buenos Aires',
        date: 'Mars 2024',
        link: 'https://events.forum-americas.org/LATAMFORUM2023-BUENOSAIRES',
        image: '/images/events/buenosAires/thumbnail-buenosaires.jpg'
      },
      {
        title: '1ère édition',
        conference: 'Phoenix Global Forum',
        date: '2 mai 2024',
        link: 'https://www.phoenixglobalforum.com/',
        image: '/images/events/phoenix/thumbnail-phoenix.jpg'
      },
      {
        title: '30ème édition',
        conference: 'La Conférence de Montréal',
        date: '10 au 12 juin 2024',
        image: '/images/events/montreal/thumbnail-montreal.jpg'
      }
    ]
  },
  specialEvents: {
    title: 'Événements spéciaux',
    content: ''
  },
  pastEvents: {
    title: 'Événements passés',
    index: [
      {
        title: 'Réussir dans un monde en transition',
        conference: 'La Conférence de Montréal',
        date: '12 au 14 juin 2023',
        link:
          'https://events.forum-americas.org/TheConferenceofMontreal2023-ThrivinginaWorldinTransition-Development#/?lang=fr',
        image: '/images/events/montreal/montreal-29th-fr.png'
      },
      {
        title: "Engagement social des entreprises pour l'égalité des genres",
        conference: 'FEIA & The Canadian Women’s Foundation',
        image: '/images/events/Corporate citizenship for gender equality.png',
        link: 'https://events.forum-americas.org/CorporateCitizenshipforGenderEquality#/?lang=fr',
        date: '8 mars 2023'
      },
      {
        title: 'Faire face aux perturbations',
        conference: 'La Conférence de Paris',
        image: '/images/events/paris/Tackling Growing Disruption.png',
        link: 'https://events.forum-americas.org/TheConferenceofParis2022-MasteringanewworldRedefiningdialogue',
        date: '15-15 décembre 2022'
      },
      {
        title: 'MasterClass ENGIE 2.0',
        conference: 'La Conférence de Paris',
        image: '/images/events/paris/master-class=2022.png',
        link: 'https://events.forum-americas.org/LaConfrencedeParis2022-MasterClassENGIE-20',
        date: '15-15 décembre 2022'
      },
      {
        title: 'Cooperation for a sustainable world',
        conference: 'IEFA LatAm forum | Buenos aires',
        image: '/images/events/buenosAires/thumbnail-buenosaires.jpg',
        link: 'https://events.forum-americas.org/LATAMFORUMofBuenosAires2022',
        date: '15-15 novembre 2023'
      },
      {
        title: 'Investing in trust',
        conference: 'World Strategic Forum | Miami',
        image: '/images/events/miami/Investing in trust.png',
        link: 'https://events.forum-americas.org/WORLDSTRATEGICFORUM2022-MIAMI',
        date: '31 octobre - 1 novemvre 2022'
      },
      {
        title: 'Charting a new economy',
        conference: 'Toronto Global Forum',
        image: '/images/events/toronto/Charting a new economy.png',
        link: 'https://events.forum-americas.org/TorontoGlobalForum2022',
        date: '17-19 octobre 2022'
      }
    ]
  }
}
